import { useEffect, useRef } from 'react';

export default function TelecomHero() {
  const headingRef = useRef<HTMLHeadingElement>(null);
  const subRef = useRef<HTMLParagraphElement>(null);
  const descRef = useRef<HTMLParagraphElement>(null);

  useEffect(() => {
    const items = [subRef.current, headingRef.current, descRef.current];
    items.forEach((el, i) => {
      if (!el) return;
      el.style.opacity = '0';
      el.style.transform = 'translateY(28px)';
      setTimeout(() => {
        if (!el) return;
        el.style.transition = 'opacity 0.8s ease, transform 0.8s ease';
        el.style.opacity = '1';
        el.style.transform = 'translateY(0)';
      }, 200 + i * 200);
    });
  }, []);

  return (
    <section className="relative min-h-[72vh] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/edited_be839777aab047922b9f91363bd43deb_03e38b2d.jpg"
          alt="Telecommunications infrastructure"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-[#001F4E]/80 via-[#001F4E]/65 to-[#001F4E]/85" />
      </div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 lg:px-10 text-center pt-24 pb-16">
        <p
          ref={subRef}
          className="text-[#00A3E0] text-sm font-semibold uppercase tracking-widest mb-5"
        >
          Holston Development Group | Telecommunications Division
        </p>
        <h1
          ref={headingRef}
          className="text-4xl sm:text-5xl lg:text-6xl font-bold text-white leading-tight max-w-5xl mx-auto"
        >
          Telecommunications
          <br />
          <span className="text-[#00A3E0]">A&amp;E and Management Services</span>
        </h1>
        <p
          ref={descRef}
          className="text-white/80 text-lg max-w-2xl mx-auto mt-6 leading-relaxed"
        >
          Comprehensive architecture, engineering, and management services for the telecommunications and infrastructure industries, delivered across 20+ states with local expertise and nationwide reach.
        </p>
      </div>
    </section>
  );
}
